import { GraduationCap, Building2, Shirt, ArrowUpRight } from "lucide-react";
import { Reveal, scrollToSection } from "@/components/Reveal";

const PATHS = [
  {
    icon: GraduationCap,
    kicker: "G.A.M.E. Mentorship and Training Inc. · Nonprofit",
    title: "Mentorship & Youth Development",
    msg: "Creating opportunities. Building future leaders.",
    cta: "Explore Nonprofit",
    target: "#nonprofit",
    tid: "pathway-nonprofit",
  },
  {
    icon: Building2,
    kicker: "Future / Proposed",
    title: "G.A.M.E. Training Campus",
    msg: "Where Athletic Excellence Meets Academic Achievement.",
    cta: "Explore Campus",
    target: "#campus",
    tid: "pathway-campus",
  },
];

export const Pathways = () => (
  <section className="py-20 sm:py-28 px-4 sm:px-8 lg:px-16" data-testid="pathways-section">
    <Reveal>
      <div className="font-mono text-xs sm:text-sm tracking-[0.3em] uppercase text-[#FFB800] mb-4">Two Pathways. One Mission.</div>
      <h2 className="font-display font-black uppercase tracking-tight leading-none text-3xl sm:text-4xl lg:text-6xl text-[#F4F4F6]">
        Choose your <span className="text-outline">lane.</span>
      </h2>
    </Reveal>
    <div className="mt-14 grid grid-cols-1 md:grid-cols-2 gap-6">
      {PATHS.map((p, i) => (
        <Reveal key={p.title} delay={i * 0.1}>
          <div
            className="group h-full border border-[#242436] hover:border-[#8B5CF6]/60 bg-[#111118] hover:bg-[#161622] p-8 flex flex-col transition-colors duration-300 shadow-[0_4px_30px_rgba(0,0,0,0.5)]"
            data-testid={p.tid}
          >
            <div className="flex items-start justify-between">
              <p.icon className="w-9 h-9 text-[#8B5CF6]" strokeWidth={1.75} />
              <span className="font-mono text-[9px] uppercase tracking-[0.15em] text-[#62627A] text-right max-w-[140px] leading-relaxed">{p.kicker}</span>
            </div>
            <h3 className="font-display font-black uppercase tracking-wide text-2xl sm:text-3xl text-[#F4F4F6] mt-8">{p.title}</h3>
            <p className="text-sm leading-relaxed text-[#A1A1B3] mt-3 flex-1">{p.msg}</p>
            <button
              onClick={() => scrollToSection(p.target)}
              data-testid={`${p.tid}-cta`}
              className="mt-8 flex items-center gap-2 font-display font-bold uppercase tracking-wider text-sm text-[#FFB800] hover:text-[#F4F4F6] transition-colors duration-200 w-fit"
            >
              {p.cta}
              <ArrowUpRight className="w-4 h-4 group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform duration-300" />
            </button>
          </div>
        </Reveal>
      ))}
    </div>
  </section>
);
